import React from "react";
import "../css/petAdopterCard.css";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function PetAdopterCard() {
  const [userData, setUserData] = useState([]);
  const [questions, setQuestion] = useState([]);
  const [petData, setPetData] = useState([]);
  const [busy, setBusy] = useState(false);


 const navigate = useNavigate();






  const params = useParams();
  const email = params.email;

  
    const handleButton = async (value) => {
      try {
        setBusy(true)
        await axios.post(`https://petme.onrender.com/user/mailSender?email=${email}`, { value });
        setBusy(false)
        console.log('Email sent successfully');
        navigate("/PetAdopterTable")
      } catch (error) {
        console.error('Error sending email:', error);
      }
    }


  const fetchPetData = async ()=>{
    try {
        const response = await fetch(`https://petme.onrender.com/api/pets/findPet?_id=${questions.petid}`)
        const data = await response.json();
        setPetData(data[0])
    } catch (error) {
      console.log(error)
    }
  }

  const fetchUserData = async () => {
    try {
      const response = await fetch(`https://petme.onrender.com/user/adopterInfo?email=${email}`); 
      const data = await response.json();
      setUserData(data[0]);
    } catch (error) {
      console.error(error);
    }
  };
  
  const fetchQuestion = async () => {
    try {
      const response = await fetch(`https://petme.onrender.com/api/pets/questions?email=${email}`); 
      const data = await response.json();
      setQuestion(data[0]);
    } catch (error) {
      console.error(error);
    }
  };
  
  useEffect(() => {
    fetchUserData();
    fetchQuestion();
    fetchPetData();
  }, [questions]);


  if(busy){
    <h1>plese wait......</h1>
  }


  
  
  
    return (
        <div>
            <section className="adopterCard-section">

                <h2 className="adopterCard-heading">Pet Adopter Details</h2>

                <div className="adopterCard-detailsDiv">
                    <div className="row adopterCardRow">

                        <div className="adopterCart-detailsDiv">
                            <p className="adopterCardDetails adopterName">Adopter Name: <span className="adopterCard-detailsValue">{userData.firstname} {userData.name} </span></p>
                            <p className="adopterCardDetails adopterEmail">Email: <span className="adopterCard-detailsValue">{userData.email} </span></p>
                            {petData && petData.petname && ( 
                            <p className="adopterCardDetails adopterPettName">
                              Pet Name: <span className="adopterCard-detailsValue">{petData.petname}</span>
                            </p>
                          )}
                            <p className="adopterCardDetails dateOfApplication-adopter">Date Of Application: <span className="adopterCard-detailsValue">05 Nov 2022</span></p>
                        </div>

                        <div className="adopterCard-petImgDiv" >
                           {petData && petData.petImageUrl&&(<img className="adopterCard-petImg" src={petData.petImageUrl} alt="pet_image" />)} 
                        </div>

                    </div>
                </div>

                {(!userData.question&&<>
                <div className="adopterQuestionnaireDiv">

                    <h2 className="adopterCard-questionnaireHeading">Questionnaire</h2>

                    <div className="adopterCard-questionnaireFields">
                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">Have you owned a pet before? Why is he/she not with you anymore? Tell us about him/her.</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question1}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">Do you currently have any pet(s) at home? Tell us about him/her/them.</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question2}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">Are there children in your household? What is age of the children ? Do they like animals?</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question3}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">What is your living situation (house, apartment, etc.)? What floor do you live on?</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question4}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">How is the behavior of your neighbors towards pets?</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question5}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">Are there any restrictions on pet ownership in your building or neighborhood?</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question6}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">Are you willing and able to provide daily exercise and outdoor time for the pet? How much time are you going to spend with the pet?</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question7}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">What are your expectations from adopting a pet?</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question8}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">Are there any specific preferences or requirements you have in mind for the pet's behavior or characteristics?</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question9}</p>
                        </div>

                        <div className="adopterCard-questionDiv">
                            <p className="adopterCard-questionnaireQuestion">Are you committed to providing necessary veterinary care, grooming, and training for the pet? If yes, could you please describe briefly how you plan to manage and prioritize these responsibilities.</p>
                            <p className="adopterCard-questionnaireAnswer">{questions.question10}</p>
                        </div>
                    </div>

                </div>

                <div className="adopterCard-btnDiv">
                    <button className="adopterCardBtn adopterCard-approveBtn"  onClick={() => handleButton('approve')}>APPROVED</button>
                    <button className="adopterCardBtn adopterCard-rejectBtn" onClick={() => handleButton('reject')}>REJECTED</button>
                </div>
                </>)}

                {(userData.questions&&<>
                
                <div className="adopterCard-btnDiv">
                    <button className="adopterCardBtn adopterCard-approveBtn"  onClick={() => handleButton('visit')}>APPROVED</button>
                    <button className="adopterCardBtn adopterCard-rejectBtn" onClick={() => handleButton('novisit')}>REJECTED</button>
                </div>

                </>)}

                {(userData.visit&&<>
                <h3>This user is verified</h3>
                </>)}

                

            </section >

        </div >
    );
}

export default PetAdopterCard